// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__CYRBm","insightsList":"newBusinessInsightsMenu_insightsList__2OVur","active":"newBusinessInsightsMenu_active__A_4n2"};